import { AgentProfileService } from './_services/agent.profile.service';
import { RouterModule, Routes } from '@angular/router';

import { DetailsComponent } from './details/details.component';
import { OpcoFormComponent } from './opco/opco-form.component';
import { SearchFormComponent } from './search/search-form.component';
import { SmsurlComponent } from './smsurl/smsurl.component';
import { SmscloseComponent } from './smsurl/smsclose.component'
import { SiteLayoutComponent } from './site-layout/site-layout.component';

const routes: Routes = [
    {
        path: '',
        component: SiteLayoutComponent,
        children: [
          { path: '', component: OpcoFormComponent, data: { breadcrumb: 'Select opco' } },
          { path: ':opco/search/:country', component: SearchFormComponent, data: { breadcrumb: 'Search' } },
          { path: ':opco/search', component: SearchFormComponent, data: { breadcrumb: 'Search' } },
          { path: ':opco/details/:sub', component: DetailsComponent, data: { breadcrumb: 'Details'} },
          { path: ':opco/details/:sub/country/:country', component: DetailsComponent, data: { breadcrumb: 'Details'} }
        ]
    },
    { path: ':smsurl', component: SmscloseComponent, data: { breadcrumb: 'Close'}},
    { path: ':smsurl/:tokenId/code/:pincode', component: SmsurlComponent, data: { breadcrumb: 'Smsurl' } },
    { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts